import { Avatar } from '@chakra-ui/avatar';
import { Box, Text, Flex } from '@chakra-ui/layout';
import React from 'react';
import ConnectionButton from '../connectionButton/ConnectionButton';
import { Image, Tooltip } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InvestorBanner from '../../public/images/investor_dashboard.jpg';
import classNames from 'classnames';
import { FaStar } from 'react-icons/fa';
import { FiCheckCircle } from 'react-icons/fi';
import LockedField from '../LockedField';

const NewSingleInvestor = ({
  investor,
  onToggle,
  setSelectedInvestor,
  isSwiper = false,
  subscriptionPlanName,
}) => {
  const navigate = useNavigate();
  const viewDetails = () => {
    navigate(
      `/view-user?userid=${investor?.id}&usertype=${investor?.userTypeId}`,
    );
    window.scrollTo(0, 0);
  };
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state?.user?.userInfo);
  const loggedInUserSubscription = useSelector(
    (state) => state?.user?.userSubscriptionInfo,
  );
  const loggedInUserType = userDetails?.userTypeTitle || '';

  const SUBSCRIPTION_FLAG = process.env.REACT_APP_SUBSCRIPTION_FLAG;

  const currentPlanName = loggedInUserSubscription?.subscription_plan?.name;

  const isFreePlan = currentPlanName?.trim().toLowerCase().includes("free");


  const getVerificationBadge = () => {
    // Only show badge if logged in user is a founder
    if (loggedInUserType?.toLowerCase() !== 'founder') {
      return null;
    }

    const planNameLower = subscriptionPlanName?.toLowerCase();

    if (planNameLower?.includes('pro')) {
      return {
        text: 'Premium Verified',
        bgColor: '#FFD700', // Gold
        textColor: '#000',
        borderColor: '#FFA500',
      };
    } else if (planNameLower?.includes('starter')) {
      return {
        text: 'Verified',
        bgColor: '#22C55E', // Green
        textColor: '#fff',
        borderColor: '#16A34A',
      };
    }
    // Free plan - no badge
    return null;
  };

  const verificationBadge = getVerificationBadge();

  return (
    <Box
      cursor="pointer"
      onClick={viewDetails}
      style={{ flex: '1 1 300px' }}
      className={classNames({
        'w-[100%] px-3 pt-3 pb-1 relative border border-[#DBE2ED] rounded-lg': true,
        'min-w-[290px] md:max-w-[300px] sm:w-[45%] sm:max-w-[350px] xl:w-[43%] xl:max-w-[390px] 2xl:max-w-[300px]':
          !isSwiper,
      })}
    >
      {investor?.is_featured ? (
        <Flex className="flex-row justify-start absolute top-0 left-[-1px] z-[1] w-full">
          <Tooltip label="Company is featured">
            <span>
              <FaStar
                className="cursor-pointer bg-yellow-500 rounded-full p-1"
                size={'18px'}
              />
            </span>
          </Tooltip>
        </Flex>
      ) : null}
      <Flex className="flex-col">
        <Box
          className="rounded-md"
          w="100%"
          h="120px"
          bg="lightgray"
          position="relative"
        >
          {investor?.cover_image && (
            <Box
              className="rounded-md"
              position="absolute"
              top="0"
              w="100%"
              h="120px"
              overflow="hidden"
            >
              <Image
                src={investor?.cover_image}
                objectFit="cover"
                position="absolute"
                top="0"
              />
            </Box>
          )}
          {!investor?.cover_image && (
            <Box className="rounded-md" h="120px" w="100%" overflow="hidden">
              <Image
                src={InvestorBanner}
                objectFit="cover"
                w="100%"
                h="120px"
                className="object-left w-full h-full"
              />
            </Box>
          )}
        </Box>
        <Box className="flex flex-col px-3">
          <Box className="w-full flex justify-end" mt="-25px">
            <Avatar
              w={'58px'}
              h={'58px'}
              className="borde-white border-[2px]"
              name={investor?.company?.title}
              src={investor.profile_image}
            />
          </Box>
          <Box w="80%">
            <Flex
              w="90%"
              className="relative mt-[-25px] space-between"
              justifyContent={'space-between'}
              alignItems="center"
              overflow="hidden"
              gap={2}
            >
              <Flex alignItems="center" gap={1.5} flex={1} minW={0}>
                <Text
                  className="font-semibold"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  overflow="hidden"
                  fontSize="1rem"
                >
                  {`${investor.company.title}`}
                </Text>
                {verificationBadge && (
                  <Box
                    className="flex items-center gap-1 text-[9px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap border border-1.5 flex-shrink-0"
                    style={{
                      backgroundColor: verificationBadge.bgColor,
                      color: verificationBadge.textColor,
                      borderColor: verificationBadge.borderColor,
                    }}
                  >
                    <FiCheckCircle size={10} />
                    {verificationBadge.text}
                  </Box>
                )}
              </Flex>
            </Flex>
          </Box>
        </Box>
        <Flex className="flex-col p-3 gap-2" w="100%">
          <Box maxW="100%" py={1}>
            {SUBSCRIPTION_FLAG == "on" && isFreePlan ?
              <Box className="preview_message">
                <LockedField
                  value={investor?.company?.description}
                  onUpgrade={() => navigate(`${window.location.pathname}?upgrade=true`)}
                  showUpgradeButton={false}
                />
              </Box>
              : (
                <Text
                  className="preview_message text-xs"
                  color="#000"
                  textOverflow="ellipsis"
                >
                  {investor?.company?.description}
                </Text>
              )}
          </Box>

          <Box>
            <Box className="flex gap-2 flex-wrap mb-1 pb-4 border-b border-[#E9E9E9] min-h-[75px] items-start">
              {/* {investor?.company?.company_stage?.map(({title}) => <Box className="bg-[#FFE3AC] border border-1.5 text-[9px] font-medium border-[#EC981C] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">{title}</Box> )} */}
              {investor?.company?.company_stage?.length > 0 ? (
                <Box className="bg-[#FFE3AC] border border-1.5 text-[9px] font-medium border-[#EC981C] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                  {investor?.company?.company_stage[0].title}
                </Box>
              ) : null}
              {investor.company.fund_category?.title ? (
                <Box className="bg-[#DDFBE7] border border-1.5 text-[9px] font-medium border-[#8BDCAD] p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                  {investor?.company.fund_category?.title}
                </Box>
              ) : null}
              {/* {investor?.company?.incorporation_location?.map(({name}) => <Box className="bg-[#DBE2ED] border border-1.5 text-[9px] font-medium border-gray-200 p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">{name}</Box> )} */}
              {investor?.company?.incorporation_location?.length > 0 ? (
                <Box className="bg-[#DBE2ED] border border-1.5 text-[9px] font-medium border-gray-200 p-1 whitespace-nowrap px-2 min-w-[60px] rounded-full text-center">
                  {investor?.company?.incorporation_location[0]?.name}
                </Box>
              ) : null}
            </Box>
          </Box>
          <Box display={'none'} className="hidden mb-2 gap-2.5">
            <Box className="flex flex-col gap-1 min-w-[65px] border-r pr-3 border-[#E9E9E9] ">
              <Text className="text-[10px] text-[#C0BCBC]">Valuation</Text>
              <Text className="text-lg font-medium">-</Text>
            </Box>
            <Box className="flex flex-col gap-1 min-w-[65px]  border-r pr-3 border-[#E9E9E9] ">
              <Text className="text-[10px] text-[#C0BCBC]">Target</Text>
              <Text className="text-lg font-medium">
                {investor.company.fund_category?.title
                  ? investor.company.fund_category?.title?.includes('-')
                    ? investor.company.fund_category?.title?.split('-')[1]
                    : investor.company.fund_category?.title
                  : '-'}
              </Text>
            </Box>
            <Box className="flex flex-col  min-w-[65px] gap-1 ">
              <Text className="text-[10px] text-[#C0BCBC]">Investors</Text>
              <Text className="text-lg font-medium">-</Text>
            </Box>
          </Box>
          <Flex className="justify-center">
            <ConnectionButton user={investor} />
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};


export default NewSingleInvestor;